module.exports = __webpack_public_path__ + "static/media/vcu-son-logo.8556ad93.svg";